import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  CameraIcon,
  PackagePlusIcon,
  RotateCcwIcon,
  SearchCheckIcon,
  VideoIcon,
} from '@/shared/ui/icons';
import { PageHeader } from '@/shared/ui/layout/PageHeader';
import { FeaturesSettingsSettingsRow } from '@/features/settings';

export const PagesServicesListMain = () => {
  const { t } = useTranslation('services');
  const navigate = useNavigate();

  return (
    <>
      <PageHeader title={t('sectionTitle')} showBack backTo="/settings" />
      <div className="flex flex-col gap-4 p-4 md:mx-auto md:w-full md:max-w-2xl lg:p-6">
        <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-card">
          <FeaturesSettingsSettingsRow
            icon={<CameraIcon className="h-5 w-5" />}
            label={t('sendPhoto')}
            onClick={() => navigate('/services/photo')}
          />
          <div className="border-t border-slate-100" />
          <FeaturesSettingsSettingsRow
            icon={<VideoIcon className="h-5 w-5" />}
            label={t('sendVideo')}
            onClick={() => navigate('/services/video')}
          />
          <div className="border-t border-slate-100" />
          <FeaturesSettingsSettingsRow
            icon={<SearchCheckIcon className="h-5 w-5" />}
            label={t('proverkaService')}
            onClick={() => navigate('/services/proverka')}
          />
          <div className="border-t border-slate-100" />
          <FeaturesSettingsSettingsRow
            icon={<RotateCcwIcon className="h-5 w-5" />}
            label={t('returnService')}
            onClick={() => navigate('/services/return')}
          />
          <div className="border-t border-slate-100" />
          <FeaturesSettingsSettingsRow
            icon={<PackagePlusIcon className="h-5 w-5" />}
            label={t('splitParcel')}
            onClick={() => navigate('/services/split')}
          />
        </div>
      </div>
    </>
  );
};
